<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card>
        <v-card-title class="modal-header elevation-10">
          <v-row>
            <v-col>
              <slot name="title">Avaliar Relatório</slot>
            </v-col>
            <v-col class="text-right">
              <v-icon @click="closeReport" color="white"
                >mdi-window-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <label class="v-label">Título do Relatório</label>
              <div class="report-title">{{ report.titulo }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="report.encontro.grupo.nome"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div class="contract-section">
                <label class="v-label">Número do Contrato</label>
                <div class="contract-info">
                  <span class="contract-number">{{
                    contrato?.numContrato || "N/A"
                  }}</span>
                  <v-tooltip bottom max-width="400">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="ml-2"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div class="contract-tooltip">
                      <div>
                        <strong>Número:</strong>
                        {{ contrato?.numContrato || "N/A" }}
                      </div>
                      <div>
                        <strong>Natureza:</strong>
                        {{ contrato?.natureza || "N/A" }}
                      </div>
                      <div>
                        <strong>Vigência:</strong>
                        {{ formatDateRange(contrato?.inicio, contrato?.fim) }}
                      </div>
                      <div>
                        <strong>Horas Previstas:</strong>
                        {{ contrato?.qtdHorasPrevistas || "N/A" }}
                      </div>
                      <div>
                        <strong>Valor/Hora:</strong>
                        {{ formatCurrency(contrato?.valorHora) }}
                      </div>
                      <div v-if="contrato?.qtdEntregasPrevistas">
                        <strong>Entregas Previstas:</strong>
                        {{ contrato?.qtdEntregasPrevistas }}
                      </div>
                    </div>
                  </v-tooltip>
                </div>
              </div>
            </v-col>
            <v-col>
              <div class="contract-section">
                <label class="v-label">Tipo de Produto </label>
                <div class="report-title">
                  {{ municipioSolucao?.solucaoTipo?.solucaoTipoNome || "N/A" }}
                </div>
              </div>
            </v-col>
            <v-col>
              <div class="contract-section">
                <label class="v-label">Objeto do Contrato</label>
                <div class="report-title">
                  <v-tooltip
                    bottom
                    max-width="600"
                    v-if="
                      contrato?.descricao && contrato?.descricao.length > 100
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="contract-description-truncated"
                      >
                        {{ truncateText(contrato.descricao, 100) }}...
                      </span>
                    </template>
                    <div class="contract-description-full">
                      {{ contrato.descricao }}
                    </div>
                  </v-tooltip>
                  <span v-else>
                    {{ contrato?.descricao || "N/A" }}
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                v-model="report.inicioString"
                v-mask="'##/##/#### ##:##'"
                label="Data de Início"
                placeholder="00/00/0000 00:00"
                disabled
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                v-model="report.fimString"
                v-mask="'##/##/#### ##:##'"
                label="Data de Término"
                placeholder="00/00/0000 00:00"
                disabled
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                v-model="report.horasUtilizadasString"
                label="Horas Utilizadas"
                placeholder="00"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <combobox-encontro-tipo
                :filter="report"
                :readonly="true"
              ></combobox-encontro-tipo>
            </v-col>
            <template
              v-if="report.tipoExecucaoRelatorioId === encontroTipoEnum.hibrido"
            >
              <v-col>
                <v-text-field
                  v-model="report.horasPresenciaisString"
                  label="Horas Presenciais"
                  placeholder="00"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="report.horasRemotasString"
                  label="Horas Remotas"
                  placeholder="00"
                  disabled
                ></v-text-field>
              </v-col>
            </template>
          </v-row>
          <v-row>
            <v-tabs vertical v-model="tab">
              <v-tab :value="0">
                <v-icon left>mdi-file-chart</v-icon>
                Relatório
              </v-tab>
              <v-tab :value="1">
                <v-icon left>mdi-account-multiple-plus</v-icon>
                Convidados
              </v-tab>
              <v-tab @click="onAnexosTabClick" :value="2">
                <v-icon left>mdi-attachment</v-icon>
                Anexos
              </v-tab>
              <v-tab :value="3">
                <v-icon left>mdi-calendar-check-outline</v-icon>
                {{ isAT ? "Iniciativas" : "Tarefas" }}
              </v-tab>
              <v-tab :value="4">
                <v-icon left>mdi-android-messages</v-icon>
                Observações
              </v-tab>

              <!-- relatorio -->
              <v-tab-item>
                <v-col>
                  <v-textarea v-model="report.descricao" readonly></v-textarea>
                  <div
                    v-if="canViewFullScreenReport"
                    class="full-screen-report-action"
                  >
                    <v-btn
                      small
                      outlined
                      color="primary"
                      @click="openFullScreen"
                    >
                      Ver em tela inteira
                    </v-btn>
                  </div>
                </v-col>
              </v-tab-item>
              <!-- convidados -->

              <v-tab-item>
                <v-data-table
                  :headers="headersConvidados"
                  :items="report.convidados"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.presente="{ item }">
                    <v-checkbox
                      v-model="item.presente"
                      :id="'membro' + item.membroId"
                      color="primary"
                      disabled
                    >
                    </v-checkbox>
                  </template>

                  <template slot="no-data">
                    <span> Nenhum convidado retornado </span>
                  </template>
                </v-data-table>
              </v-tab-item>
              <!-- Anexos -->

              <v-tab-item>
                <v-data-table
                  :headers="headersAnexos"
                  :items="report.anexos"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.nome="{ item }">
                    <span class="anexo-nome">{{ item.nome }}</span>
                  </template>
                  <template v-slot:item.download="{ item }">
                    <v-btn
                      outlined
                      color="primary"
                      class="ml-3"
                      @click="downloadAnexo(item)"
                    >
                      <span>Download</span>
                    </v-btn>
                  </template>

                  <template slot="no-data">
                    <span> Nenhum anexo retornado </span>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- possui iniciativa -->
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="report.tarefas"
                  class="elevation-1"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.cumprida="{ item }">
                    <v-checkbox
                      v-model="item.cumprida"
                      :id="'cumprida' + item.tarefaId"
                      color="primary"
                      disabled
                    >
                    </v-checkbox>
                  </template>
                  <template
                    v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{
                      item,
                    }"
                  >
                    <span
                      v-for="evidencia in item.municipioTarefa
                        .municipioEvidencias"
                      :key="evidencia.municipioEvidenciaId"
                    >
                      {{ evidencia.nome }} |
                    </span>
                  </template>

                  <template slot="no-data">
                    <span> Nenhuma tarefa retornada </span>
                  </template>
                </v-data-table>
              </v-tab-item>
              <!-- observações -->
              <v-tab-item>
                <v-col>
                  <v-textarea
                    v-model="report.observacoes"
                    readonly
                  ></v-textarea>
                </v-col>
              </v-tab-item>
            </v-tabs>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Motivo da rejeição"
                v-model="report.motivoRejeicao"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="modal-footer modal-footer-fixed flex-shrink-0">
          <v-row
            v-if="
              report.statusRelatorioId === 2 || report.statusRelatorioId === 3
            "
          >
            <v-col>
              <v-alert
                :type="report.statusRelatorioId === 2 ? 'success' : 'error'"
                outlined
                dense
                class="analysis-alert ma-0"
                :icon="
                  report.statusRelatorioId === 2
                    ? 'mdi-check-circle-outline'
                    : 'mdi-close-circle-outline'
                "
              >
                <div class="analysis-message">
                  <strong>
                    {{
                      report.statusRelatorioId === 2
                        ? "Relatório Aprovado"
                        : "Relatório Reprovado"
                    }}
                  </strong>
                  <div class="analysis-details">
                    <span v-if="report.usuarioAnaliseNavigation?.nome">
                      Analisado por:
                    </span>
                    <div v-if="report.dataAnalise">
                      {{ report.usuarioAnaliseNavigation.nome }}
                      <div>{{ formatDateTime(report.dataAnalise) }}</div>
                    </div>
                  </div>
                </div>
              </v-alert>
            </v-col>
          </v-row>

          <div
            v-if="report.statusRelatorioId === 4"
            class="payment-status-footer"
          >
            <v-alert
              type="success"
              outlined
              dense
              class="payment-alert-footer ma-0"
              icon="mdi-cash-check"
            >
              <div class="payment-message-footer">
                <strong>Inserido no processo de pagamento</strong>
                <div
                  v-if="getPaymentNumbers().length > 0"
                  class="payment-numbers"
                >
                  Número: {{ getPaymentNumbers().join(", ") }}
                </div>
              </div>
            </v-alert>
          </div>
          <div class="flex-grow-1"></div>

          <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
          <v-btn
            color="info"
            outlined
            text
            @click="save(2)"
            v-if="
              (isFullAdmin ||
                (config.podeAnalisarRelatorio &&
                  groupsConfig.podeAnalisarRelatorio)) &&
              report.statusRelatorioId !== 4
            "
            >Aprovar</v-btn
          >
          <v-btn
            color="info"
            outlined
            text
            @click="save(3)"
            v-if="
              (isFullAdmin ||
                (config.podeAnalisarRelatorio &&
                  groupsConfig.podeAnalisarRelatorio)) &&
              report.statusRelatorioId !== 4
            "
            >Rejeitar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fullScreenDialog" fullscreen>
      <v-card class="full-screen-report-card">
        <v-card-title class="full-screen-report-header">
          <span>Relatório em tela inteira</span>
          <v-spacer></v-spacer>
          <v-btn icon x-large @click="closeFullScreen" aria-label="Fechar">
            <v-icon size="38">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="full-screen-report-content">
          <div class="full-screen-report-text">{{ report.descricao }}</div>
        </v-card-text>

        <v-card-actions class="full-screen-report-footer">
          <v-spacer></v-spacer>
          <v-btn large outlined color="primary" @click="closeFullScreen">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ComboboxEncontroTipo from "@/components/calendar/encontroTipo/ComboboxEncontroTipo.vue";
import { encontroTipoEnum } from "@/components/calendar/encontroTipo/encontroTipoEnum.js";
export default {
  name: "AppModalAnalyseReport",
  props: {
    dialog: { type: Boolean, default: false },
    id: { type: Number, required: false },
  },
  components: {
    ComboboxEncontroTipo,
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isAT",
    ]),
    contrato() {
      const municipioSolucao = this.report?.encontro?.grupo?.municipioSolucao;
      const contratosPorUsuario = municipioSolucao?.municipioSolucaoContrato || [];
      const contratoDoAutor = contratosPorUsuario
        .map((item) => item?.contrato)
        .find((contrato) => contrato?.usuarioId == this.report?.usuarioId);

      return contratoDoAutor || municipioSolucao?.contratoRelacao;
    },
    municipioSolucao() {
      return this.report?.encontro?.grupo?.municipioSolucao;
    },
    canViewFullScreenReport() {
      return (
        this.config?.verRelatorioTelaInteira &&
        this.groupsConfig?.verRelatorioTelaInteira
      );
    },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Horas", value: "municipioTarefa.horas" },
        { text: "Cumprida", value: "cumprida" },

        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
        {},
      ],
      headersConvidados: [
        { text: "Nome", value: "convidado.nome" },
        { text: "CPF", value: "convidado.cpf" },
        { text: "E-mail", value: "convidado.email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      estado: this.$store.state.uf,
      anexosCarregados: false,
      anexosCache: [],
      fullScreenDialog: false,
      tab: 0, // Aba inicial
      encontroTipoEnum: encontroTipoEnum,
      report: {
        arquivos: [],
        convidadosRelatorio: [],
        tarefasRelatorio: [],
        municipio: {},
        encontro: {
          grupo: {},
          solucoes: [{ numero: 0 }],
        },
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onAnexosTabClick() {
      if (this.anexosCarregados) {
        this.report.anexos = this.anexosCache;
        return;
      }

      this.carregarAnexos();
    },
    carregarAnexos() {
      this.setLoading(true);

      reportAPI
        .getRelatorioAnexos(this.report.relatorioId)
        .then((resp) => {
          this.anexosCache = resp.data;
          this.report.anexos = resp.data;
          this.anexosCarregados = true;

          this.setLoading(false);
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("Erro ao carregar anexos:", error);
          this.$notification.error("Erro ao carregar anexos");
          this.setLoading(false);
        });
    },
    closeReport() {
      this.fechar();
    },
    fechar() {
      this.tab = 0;
      this.closeFullScreen();
      this.resetarCacheAnexos();
      this.$emit("onCloseReport");
    },
    openFullScreen() {
      this.fullScreenDialog = true;
    },
    closeFullScreen() {
      this.fullScreenDialog = false;
    },
    save(statusId) {
      if (statusId === 3 && !this.report.motivoRejeicao) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.report.statusRelatorioId = statusId;
        let formData = new FormData();

        if (this.report.anexos && this.report.anexos.length > 0) {
          for (let i = 0; i < this.report.anexos.length; i++) {
            formData.append("arquivos", this.report.anexos[i]);
          }
        }
        formData.append("observacoes", this.report.observacoes);
        formData.append("convidados", this.report.convidados);
        formData.append(
          "tarefasRelatorioString",
          JSON.stringify(this.report.tarefas)
        );
        formData.append(
          "municipio.nome",
          JSON.stringify(this.report.municipio.nome)
        );
        formData.append("convidadosRelatorio", this.report.convidadosRelatorio);
        formData.append("criacao", this.report.criacao);
        formData.append("criacaoString", this.report.criacao);
        formData.append("descricao", this.report.descricao);
        formData.append("encontro", this.report.encontro);
        formData.append("encontroId", JSON.stringify(this.report.encontroId));
        formData.append("fim", this.report.fim);
        formData.append("fimString", this.report.fimString);
        formData.append(
          "horasPrevistasString",
          this.report.horasPrevistasString
        );
        formData.append("horasRemotasString", this.report.horasRemotasString);
        formData.append(
          "horasPresenciaisString",
          this.report.horasPresenciaisString
        );
        formData.append("horasTarefas", this.report.horasTarefas);
        formData.append(
          "horasUtilizadasString",
          this.report.horasUtilizadasString
        );
        formData.append("inicio", this.report.inicio);
        formData.append("inicioString", this.report.inicioString);
        formData.append("municipioId", JSON.stringify(this.report.municipioId));
        formData.append("relatorioId", JSON.stringify(this.report.relatorioId));
        formData.append(
          "statusRelatorioId",
          JSON.stringify(this.report.statusRelatorioId)
        );
        formData.append(
          "tipoExecucaoRelatorioId",
          this.report.tipoExecucaoRelatorioId
        );
        formData.append("titulo", this.report.titulo);
        if (this.report.motivoRejeicao) {
          formData.append("motivoRejeicao", this.report.motivoRejeicao);
        }
        if (this.report.complemento) {
          formData.append("complemento", this.report.complemento);
        }
        formData.append("usuarioId", this.report.usuarioId);

        reportAPI
          .analyse(formData)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport", this.report);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar relatório");
          });
      }
    },
    get() {
      this.setLoading(true);
      this.resetarCacheAnexos();

      reportAPI
        .get(this.id)
        .then((resp) => {
          this.report = resp.data;
          this.report.inicioString = moment(this.report.inicio).format(
            "DD/MM/YYYY HH:mm"
          );
          this.report.fimString = moment(this.report.fim).format(
            "DD/MM/YYYY HH:mm"
          );

          this.report.encontrosTipoId = this.report.tipoExecucaoRelatorioId;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    downloadAnexo(evidencia) {
      reportAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
    resetarCacheAnexos() {
      this.anexosCarregados = false;
      this.anexosCache = [];
    },
    formatCurrency(value) {
      if (!value) return "N/A";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    formatDate(date) {
      if (!date) return "N/A";
      return new Date(date).toLocaleDateString("pt-BR");
    },
    formatDateTime(date) {
      if (!date) return "N/A";
      const dateObj = new Date(date);
      return `${dateObj.toLocaleDateString("pt-BR")}`;
    },
    formatDateRange(startDate, endDate) {
      const start = this.formatDate(startDate);
      const end = this.formatDate(endDate);
      if (start === "N/A" || end === "N/A") return "N/A";
      return `${start} - ${end}`;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) : text;
    },
    getPaymentNumbers() {
      if (
        !this.report.relatorioPagamentos ||
        !Array.isArray(this.report.relatorioPagamentos)
      ) {
        return [];
      }
      return this.report.relatorioPagamentos
        .map((pagamento) => {
          // Tentando acessar diferentes possíveis campos de número
          return pagamento.relatorioGestaoPagamentoId || "N/A";
        })
        .filter((numero) => numero !== "N/A");
    },
  },
  watch: {
    id: function () {
      this.get();
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
.anexo-nome {
  word-break: break-word;
  max-width: 200px;
  display: inline-block;
}
</style>
